import { Eye, FileText, MessageSquare } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { cn } from "~/lib/utils";

export type MobileViewState = "docList" | "viewer" | "chat";

interface MobileBottomNavProps {
  activeView: MobileViewState;
  onViewChange: (view: MobileViewState) => void;
}

export function MobileBottomNav({
  activeView,
  onViewChange,
}: MobileBottomNavProps) {
  const navItems: {
    id: MobileViewState;
    icon: typeof FileText;
    labelId: string;
    defaultLabel: string;
  }[] = [
    {
      id: "docList",
      icon: FileText,
      labelId: "mobile.nav.documents",
      defaultLabel: "Documents",
    },
    {
      id: "viewer",
      icon: Eye,
      labelId: "mobile.nav.viewer",
      defaultLabel: "Viewer",
    },
    {
      id: "chat",
      icon: MessageSquare,
      labelId: "mobile.nav.chat",
      defaultLabel: "Chat",
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex h-14 items-center justify-around border-t bg-background pb-safe-bottom">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeView === item.id;
        return (
          <button
            key={item.id}
            onClick={() => onViewChange(item.id)}
            className={cn(
              "flex min-w-[64px] flex-col items-center justify-center gap-1 px-3 py-2",
              "touch-manipulation",
              isActive ? "text-primary" : "text-muted-foreground"
            )}
          >
            <Icon className="h-5 w-5" />
            <span className="text-xs font-medium">
              <FormattedMessage
                id={item.labelId}
                defaultMessage={item.defaultLabel}
              />
            </span>
          </button>
        );
      })}
    </nav>
  );
}
